export default {
  'component.country.allGroup': '全部国家/地区',
  'component.country.placeholder': '请选择国家/地区',
  'component.country.popularGroup': '常用国家/地区',
  'component.phonePrefix.allGroup': '全部',
  'component.phonePrefix.placeholder': '区号',
  'component.phonePrefix.popularGroup': '常用',

  'component.copyText.copy': '点击复制',
  'component.copyText.copied': '已复制',

  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',

  // ===== LLMMonitor =====
  'component.llmMonitor.title': 'LLM 调用',
  'component.llmMonitor.empty': '暂无 LLM 调用',
  'component.llmMonitor.inFlight': '在飞 {count}',
  'component.llmMonitor.queued': '排队 {count}',
  'component.llmMonitor.lease': '租约 {count}',
  'component.llmMonitor.loadFailed': '加载 LLM 监控失败',

  // ===== Footer =====
  'component.footer.copyright': 'AI 项目导演平台',

  // ===== HeaderDropdown =====
  'component.headerDropdown.profile': '个人中心',
  'component.headerDropdown.settings': '个人设置',
  'component.headerDropdown.logout': '退出登录',
  'component.logout.confirmTitle': '退出登录?',
  'component.logout.confirmDesc': '确认退出当前账号吗?',
};
